import { Card } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { GrFormRefresh } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardContent } from "semantic-ui-react";
import {
  addAndUpload,
  deleteDocumentList,
  getDocumentByMultipleOpeAndRef,
  getDocumentByOpeAndRef,
  updateAndUpload,
} from "../../../api/documentUpload";
import { getBulkDropdownData } from "../../../api/keyvalue";
import {
  addRequestInitiation,
  approveBackhaul,
  createAndApproveRequestInitiation,
  fetchBackhaulSuggestions,
  fetchDataById,
  fetchInsIdsByJobId,
  fetchJobConfirmationAlerts,
  fetchJobIdsByRequestId,
  updateRequestInitiation,
} from "../../../api/requestCreation";
import { consignmentsByCustomer } from "../../../api/stkConsignmentTypeApi";
import { FORMS, MODULES } from "../../../const";
import { formatFromJsonDate, isBeforeJson } from "../../../dateConfig";
import useDynamicValidation from "../../../hooks/useDynamicValidation";
import useFieldVisibility from "../../../hooks/useFieldVisibility";
import useFirstAndLastAuthorizedTab from "../../../hooks/useFirstAndLastAuthorizedTab";
import useNextAndPreviousAuthority from "../../../hooks/useNextAndPreviousAuthority";
import useUserCompany from "../../../hooks/useUserCompany";
import store from "../../../store";
import { errorActions } from "../../../store/error-slice";
import { requestActions } from "../../../store/request-slice";
import DocumentUpload from "../../DocumentUpload";
import Button from "../../input/Button";
import LoadingSpinner from "../../LoadingSpinner";
import Modal from "../../Modal";
import {
  schedulerMonthlyValidation,
  schedulerOneDayValidation,
  schedulerValidation,
} from "../../validations/RequestSchedulerCreation";
import {
  locationValidation,
  validateRequestLocation,
} from "../../validations/validateRequestCreation";
import WizardTab from "../../WizardTab";
import LocationMap from "../LocationMap";
import LocationConsigneeItem from "./LocationConsigneeItem/LocationConsigneeItem";
import RequestCreationInitiation from "./RequestCreationInitiation";
import RequestOther from "./RequestOther";
import RequestSummaryInformation from "./RequestSummaryInformation";
import RequestTransporter from "./RequestTransporter";
import JobConfirmationAlert from "./JobConfirmationAlert";
import { useNavigate } from "react-router-dom";
import Grid from "../../Grid";
import { ResizableScrollingTextRenderer } from "../../renderer/StyleRenderer";

const REQUEST_INITIATION = FORMS.REQUEST.CREATION_INFO.form;
const REQUEST_TRANSPORT = FORMS.REQUEST.TRANSPORT.form;
const START_LOCATION = FORMS.REQUEST.START_LOCATION.form;
const END_LOCATION = FORMS.REQUEST.END_LOCATION.form;
const REQUEST_SUMMARY = FORMS.REQUEST.SUMMARY.form;

/*
   context = 1 -> REQUEST CREATION OR UPDATE RIGHT AFTER REQUEST CREATION
   context = 2 -> UPDATE IN REQUEST APPROVAL
   context = 3 -> UPDATE AFTER JOB CREATION
*/

const RequestCreationRefactor = ({
  id,
  viewOnlyMode = false,
  cleanUp = false,
  cleanUpFunction = () => {},
  context,
  jobId,
}) => {
  const requestInitRef = useRef();
  const requestTransportRef = useRef();
  const requestSummaryRef = useRef();
  const requestOtherRef = useRef();
  const modalRef = useRef();
  const docRef = useRef();

  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Transaction,
    section: FORMS.REQUEST,
  });

  const allowSameLocation = useSelector(
    (state) => state.request.allowSameLocations,
  );
  const customerId = useSelector((state) => state.request.reqLCustomerId);

  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction],
  );
  const canSaveApprove =
    auth[FORMS.REQUEST.REQUEST_SAVE_APPROVE.form]?.FORM?.VIEW;
  const [nextValidated, setNextValidated] = useState(null);
  const [step, setStep] = useState(firstViableTab);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchLoading, setIsFetchLoading] = useState(false);
  const [departmentTypeOptions, setDepartmentTypeOptions] = useState([]);
  const [shipmentTypeOptions, setShipmentTypeOptions] = useState([]);
  const [shipmentCategoryOptions, setShipmentCategoryOptions] = useState([]);
  const [yesNoOptions, setYesNoOptions] = useState([]);
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  const [consignmentTypeOptions, setConsignmentTypeOptions] = useState([]);
  const [allConsignmentTypeOptions, setAllConsignmentTypeOptions] = useState(
    [],
  );
  const [locationFlagOptions, setLocationFlagOptions] = useState([]);
  const [pickDropTypeOptions, setPickDropTypeOptions] = useState([]);
  const [uomTypeOptions, setUomTypeOptions] = useState([]);
  const [timeUomOptions, setTimeUomOptions] = useState([]);
  const [chargeTypeOptions, setChargeTypeOptions] = useState([]);
  const [statusTypeOptions, setStatusTypeOptions] = useState([]);
  const [requestType, setRequestType] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [scheduleTypeOptions, setScheduleTypeOptions] = useState([]);
  const [showResetButton, setShowResetButton] = useState(false);
  const [reqContext, setReqContext] = useState(context);
  const [confirmationStatusOptions, setConfirmationStatusOptions] = useState(
    [],
  );
  const [backhaulSuggestions, setBackhaulSuggestions] = useState([]);
  const [selectedBackhaul, setSelectedBackhaul] = useState(null);
  const [createdRequestId, setCreatedRequestId] = useState(null);
  const backhaulModalRef = useRef();
  const [createdRequestCode, setCreatedRequestCode] = useState("");

  const hasLocErrors = useSelector((state) => state.request.hasLocErrors);
  const hasConErrors = useSelector((state) => state.request.hasConErrors);
  const submitted = useSelector((state) => state.request.submitted);

  const user = useSelector((state) => state.user);
  const userCompany = useUserCompany();
  const dispatch = useDispatch();
  const [hasRequestInitErrors, setHasRequestInitErrors] = useState(false);
  const [hasRequestTransportErrors, setHasRequestTransportErrors] =
    useState(false);
  const [hasRequestSummaryErrors, setHasRequestSummaryErrors] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isLocConItemLoading, setIsLocConItemLoading] = useState(false);
  const [isTransportLoading, setIsTransportLoading] = useState(false);
  const [isOtherInfoLoading, setIsOtherInfoLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentDocuments, setCurrentDocuments] = useState([]);
  const [docReference, setDocReference] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [insIds, setInsIds] = useState([]);
  const [requestTypeOptions, setRequestTypeOptions] = useState([]);
  const [confirmationTypeOptions, setConfirmationTypeOptions] = useState([]);
  const [kagTypes, setKagTypes] = useState([]);
  const reqCreateType = useSelector((state) => state.request.reqCreationType);
  const requestMultipleJobs = useSelector(
    (state) => state.request.requestMultipleJobs,
  );

  const { next, prev } = useNextAndPreviousAuthority({
    sectionKey: "stakeholder",
    minTab: 1,
    maxTab: 6,
    module: MODULES.Transaction,
    section: FORMS.REQUEST,
    currentTab: step,
    authenticated: true,
  });
  const dynamicValidationStatusStart = useDynamicValidation(
    locationValidation,
    START_LOCATION,
    true,
  );
  const dynamicValidationStatusEnd = useDynamicValidation(
    locationValidation,
    END_LOCATION,
    true,
  );

  const { validate: shouldValidateSummaryCBM } = useFieldVisibility({
    form: REQUEST_SUMMARY,
    field: "summary_cbm_validate",
    useDynamicFields: true,
  });

  const { validate: shouldValidateReqScheduler } = useFieldVisibility({
    form: REQUEST_SUMMARY,
    field: "request_scheduler",
    useDynamicFields: true,
  });

  const [jobConfirmAlerts, setJobConfirmAlerts] = useState([]);
  const [needToOpenModal, setNeedToOpenModal] = useState(false);
  const modalRef2 = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const response = await fetchJobConfirmationAlerts();
      if (response.length > 0) {
        setJobConfirmAlerts(response);
        setNeedToOpenModal(true);
      }
    })();
  }, []);

  useEffect(() => {
    if (needToOpenModal) {
      modalRef2.current.showModal();
      toast.warn("Please confirm below jobs before creating request.", {
        autoClose: 20000,
        containerId: "Modal",
      });
    }
  }, [needToOpenModal]);

  const closeModal2 = (withNavigate = true) => {
    setNeedToOpenModal(false);
    modalRef2.current.close();
    if (withNavigate) {
      navigate("/");
    }
  };

  // console.log("JobConfirmAlertConfiguration", jobConfirmAlertConfiguration);
  // useEffect(() => {
  //   (async () => {
  //     if (customerId) {
  //       const jobConfAlertConfig =
  //         await stakeholderConfigByStakeholderAndConfig(
  //           customerId,
  //           CONFIGS.JOB_CONFIRMATION_ALERT,
  //         );
  //       console.log("jobConfAlertConfig", jobConfAlertConfig);
  //       if (jobConfAlertConfig) {
  //         setJobConfirmAlertConfiguration(jobConfAlertConfig?.scnBoolean);
  //       }
  //     }
  //   })();
  // }, [customerId]);

  useEffect(() => {
    if (id) {
      (async () => {
        setIsFetchLoading(true);
        const response = await fetchDataById(id);
        setResponse(response);

        const jobIds = await fetchJobIdsByRequestId(id);
        setJobs(jobIds);

        const insIdSet = await fetchInsIdsByJobId(jobId);
        setInsIds(insIdSet);

        setEditMode(true);
      })();
    }
  }, [id, dispatch, viewOnlyMode, jobId]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      //new
      const {
        departments: departmentTypeData,
        shipment_type: shipmentTypeData,
        shipment_category: shipmentCategoryData,
        yesno: yesNoData,
        item_type: itemTypeData,
        consignment_type: consignmentTypeData,
        rlk_location: locationFlagData,
        uom: uomTypeData,
        "UOM#she_month": timeUomData,
        status: statusTypeData,
        chg_type: chargeTypeData,
        doc_type: docTypeData,
        "file_name#7": fileNameData,
        active: activeData,
        schedule_type: scheduleTypeData,
        req_commitment_type: requestTypeData,
        pick_drop_type: pickDropTypeData,
        req_creation_type: creationTypeData,
        req_confirmation_type: confirmationTypeData,
        kag_number: kagTypeData,
      } = await getBulkDropdownData([
        { key: "departments" },
        { key: "shipment_type" },
        { key: "shipment_category" },
        { key: "yesno" },
        { key: "item_type" },
        { key: "consignment_type" },
        { key: "rlk_location" },
        { key: "uom" },
        { key: "UOM", group: "she_month" },
        { key: "status" },
        { key: "chg_type" },
        { key: "doc_type" },
        { key: "file_name", group: "7" },
        { key: "active" },
        { key: "schedule_type" },
        { key: "req_commitment_type" },
        { key: "pick_drop_type" },
        { key: "req_creation_type" },
        { key: "req_confirmation_type" },
        { key: "kag_number" },
      ]);

      setDepartmentTypeOptions(departmentTypeData);
      setShipmentTypeOptions(shipmentTypeData);
      setShipmentCategoryOptions(shipmentCategoryData);
      setYesNoOptions(yesNoData);
      setItemTypeOptions(itemTypeData);
      setConsignmentTypeOptions(consignmentTypeData);
      setAllConsignmentTypeOptions(consignmentTypeData);
      setLocationFlagOptions(locationFlagData);
      setUomTypeOptions(uomTypeData);
      setTimeUomOptions(timeUomData);
      setStatusTypeOptions(statusTypeData);
      setChargeTypeOptions(chargeTypeData);
      setRequestType(requestTypeData);
      setDocumentTypeOptions(docTypeData);
      setFileNameOptions(fileNameData);
      setActiveOptions(activeData);
      setScheduleTypeOptions(scheduleTypeData);
      setPickDropTypeOptions(pickDropTypeData);
      setRequestTypeOptions(creationTypeData);
      setConfirmationTypeOptions(confirmationTypeData);
      setKagTypes(kagTypeData);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (customerId) {
        const data = await consignmentsByCustomer(customerId);
        if (data && data.length > 0) {
          setConsignmentTypeOptions(data);
        } else if (allConsignmentTypeOptions.length > 0) {
          setConsignmentTypeOptions(allConsignmentTypeOptions);
        }
      } else if (allConsignmentTypeOptions.length > 0) {
        setConsignmentTypeOptions(allConsignmentTypeOptions);
      }
    })();
  }, [customerId, allConsignmentTypeOptions]);

  const [response, setResponse] = useState({});

  useEffect(() => {
    setShowResetButton(context === 1);
  }, [context]);

  useEffect(() => {
    (async () => {
      if (editMode) {
        if (response) {
          setIsLocConItemLoading(true);
          setIsOtherInfoLoading(true);
          setIsTransportLoading(true);
          setDocReference(response.reqId);
          setReqContext(response.context);

          const documents = [];
          documents.push(...response.documentResponses);

          const data = {
            opeRefMap: {
              8: jobs,
              10: insIds,
            },
          };
          const jobDocuments = await getDocumentByMultipleOpeAndRef(data);

          Object.keys(jobDocuments).forEach((key) => {
            documents.push(...jobDocuments[key]);
          });

          setCurrentDocuments(documents);

          // Ensure doc reference is set before loading document upload component.
          setIsFetchLoading(false);

          const requestCreationInit = {
            reqCode: response.reqCode,
            reqId: response.reqId,
            reqLCustomerId: response.reqLCustomerId,
            reqCustomerName: response.reqCustomerName,
            reqBehalfOf:
              response.reqBehalfOf !== null &&
              response.reqBehalfOf !== undefined &&
              response.reqBehalfOf !== ""
                ? parseInt(response.reqBehalfOf)
                : null,
            reqBehalfOfUser: response.reqBehalfOfUser,
            reqLPlantId: response.reqLPlantId,
            reqDepartment: response.reqDepartment,
            reqBookingRequiredDate: response.reqBookingRequiredDate,
            reqBookingRequiredDateFormatted: response.reqBookingRequiredDate
              ? formatFromJsonDate(response.reqBookingRequiredDate)
              : "",
            reqContactPerson: response.reqContactPerson,
            reqContactNumber: response.reqContactNumber,
            reqContactEmail: response.reqContactEmail,
            reqShipmentType: response.reqShipmentType,
            reqExportImport: response.reqExportImport,
            reqDeliveryCutoff: response.reqDeliveryCutoff,
            reqReferanceValue: response.reqReferanceValue,
            reqType: response.reqType,
            reqInvoiceRef: response.reqInvoiceRef,
            reqVessel: response.reqVessel,
            reqVayage: response.reqVayage,
            reqConsolidateAllowed: response.reqConsolidateAllowed,
            reqPackages: response.reqPackages,
            reqPono: response.reqPono,
            reqBlno: response.reqBlno,
            reqOperationType: response.reqOperationType,
            reqDeliveryCutoffFormatted: response.reqDeliveryCutoff
              ? formatFromJsonDate(response.reqDeliveryCutoff)
              : "",
          };
          dispatch(
            requestActions.setRequest({
              reqLCustomerId: requestCreationInit.reqLCustomerId,
            }),
          );
          dispatch(
            requestActions.setRequest({
              reqBookingRequiredDate:
                requestCreationInit.reqBookingRequiredDate,
              reqCbm: response.reqCbm,
              reqQty: response.reqQty,
            }),
          );

          dispatch(requestActions.setCurrentValues({ requestCreationInit }));

          const requestSummary = {
            reqQty: response.reqQty,
            reqUom: response.reqUom,
            reqCbm: response.reqCbm,
            reqCbmUom: response.reqCbmUom,
            reqTotalKm: response.reqTotalKm,
            reqApprovedBy: response.reqApprovedBy,
            reqRemarks: response.reqRemarks,
            reqApprovedDate: response.reqApprovedDate,
            reqApprovedDateFormatted: response.reqApprovedDate
              ? formatFromJsonDate(response.reqApprovedDate)
              : "",
            reqStatus: response.reqStatus,
            requestSchedulerResponse: response.requestSchedulerResponse,
          };

          dispatch(requestActions.setCurrentValues({ requestSummary }));

          dispatch(
            requestActions.setRequest({
              reqConfirmationStatus: response.reqConfirmationStatus,
              reqCreationType: response.reqCreationType,
            }),
          );

          if (response.reqCreationType === 2) {
            dispatch(
              requestActions.setRequestMultipleJobs(
                response.requestMultipleJobResponses,
              ),
            );
          } else {
            const requestTransporter = {
              reqItemTypes: response.reqItemTypes,
              reqManageItems: response.reqManageItems,
              reqMultiConsignee: response.reqMultiConsignee,
              reqConsignmentType: response.reqConsignmentType,
              reqContainerno: response.reqContainerno,
              reqVehicleTypeId: response.reqVehicleTypeId,
              reqContainerType: response.reqContainerType,
              reqNumberOfVehicles: response.reqNumberOfVehicles,
              reqNumberOfTrailers: response.reqNumberOfTrailers,
              reqGrossWeight: response.reqGrossWeight,
              reqTotalValye: response.reqTotalValye,
              reqConsignee: response.reqConsignee,
              reqConsigneeCbm: response.reqConsigneeCbm,
              reqConsigneeQty: response.reqConsigneeQty,
              vehicleMaxCbm: response.vehicleMaxCbm,
              reqKAGNo: response.reqKAGNo,
            };

            if (response.reqVehicleTypeId) {
              dispatch(
                requestActions.setRequest({
                  vehicleMaxCbm: response?.vehicleMaxCbm,
                }),
              );
            }

            dispatch(
              requestActions.setRequest({
                reqMultiConsignee: requestTransporter.reqMultiConsignee,
              }),
            );

            let singleConsigneeData = {};

            if (requestTransporter.reqMultiConsignee === 1) {
              dispatch(
                requestActions.setCurrentValues({
                  requestTransporterData: {
                    requestTransporter,
                    singleConsigneeData,
                  },
                }),
              );
            } else {
              const firstActiveLocation =
                response.requestLocationsResponses.find(
                  (location) => location.rlkActive === 1,
                );

              const consigneeId =
                firstActiveLocation.requestConsigneesResponses &&
                firstActiveLocation.requestConsigneesResponses.length > 0
                  ? firstActiveLocation.requestConsigneesResponses[0]
                      .rcoConsignee
                  : null;

              singleConsigneeData = {
                rcoCbm: response.reqCbm,
                rcoQty: response.reqQty,
                rcoConsignee: consigneeId,
              };

              dispatch(
                requestActions.setCurrentValues({
                  requestTransporterData: {
                    requestTransporter,
                    singleConsigneeData,
                  },
                }),
              );

              dispatch(
                requestActions.setRequest({
                  singleConsignee: consigneeId,
                }),
              );
            }
          }

          setIsTransportLoading(false);

          let requestLocations = {
            requestStartLocation: {},
            requestEndLocation: {},
            requestViaLocations: [],
          };
          let requestConsignees = [];
          let id = 2;

          for (let location of response.requestLocationsResponses) {
            for (let consignee of location.requestConsigneesResponses) {
              requestConsignees.push({
                ...consignee,
                rcoId: consignee.rcoId,
                rcoCode: consignee.rcoCode,
                rcoLocation: location.rlkLocation,
                rcoConsignee: consignee.rcoConsignee,
                rcoConsignmentType: consignee.rcoConsignmentType,
                rcoCbm: consignee.rcoCbm,
                rcoQty: consignee.rcoQty,
                rcoActive: consignee.rcoActive,
                id,
              });

              id++;
            }

            if (location.rlkLocationType === 1) {
              dispatch(
                requestActions.setRequest({
                  startArrivalTime: location.rlkArrivalEta,
                }),
              );
              requestLocations = {
                ...requestLocations,
                requestStartLocation: {
                  ...location,
                  id: parseInt(location.rlkSeq) + 1,
                  rlkId: location.rlkId,
                  rlkCode: location.rlkCode,
                  rlkLocation: location.rlkLocation,
                  rlkLocationType: location.rlkLocationType,
                  rlkArrivalEta: location.rlkArrivalEta,
                  rlkArrivalEtaFormatted: formatFromJsonDate(
                    location.rlkArrivalEta,
                  ),
                  rlkDepartureEta: location.rlkDepartureEta,
                  rlkDepartureEtaFormatted: formatFromJsonDate(
                    location.rlkDepartureEta,
                  ),
                  rlkContactPersonId: location.rlkContactPersonId,
                  rlkAddress: location.rlkAddress,
                  rlkEmail: location.rlkEmail,
                  rlkContactNumber: location.rlkContactNumber,
                  rlkLon:
                    location.rlkLon !== null && location.rlkLon !== ""
                      ? parseFloat(location.rlkLon)
                      : null,
                  rlkLat:
                    location.rlkLat !== null && location.rlkLat !== ""
                      ? parseFloat(location.rlkLat)
                      : null,
                  rlkSeq: location.rlkSeq,
                  rlkActive: location.rlkActive,
                  requestConsigneesRequests: [],
                  rlkLocationContactNumber: location.rlkLocationContactNumber,
                  rlkLocationContactName: location.rlkLocationContactName,
                  rlkLocationTimeUpdated: location.rlkLocationTimeUpdated,
                  rlkPickDrop: location.rlkPickDrop,
                  rlkPickDropValue: location.rlkPickDropValue,
                },
              };
            } else if (location.rlkLocationType === 2) {
              requestLocations = {
                ...requestLocations,
                requestEndLocation: {
                  ...location,
                  id: parseInt(location.rlkSeq) + 1,
                  rlkId: location.rlkId,
                  rlkCode: location.rlkCode,
                  rlkLocation: location.rlkLocation,
                  rlkLocationType: location.rlkLocationType,
                  rlkArrivalEta: location.rlkArrivalEta,
                  rlkArrivalEtaFormatted: formatFromJsonDate(
                    location.rlkArrivalEta,
                  ),
                  rlkDepartureEta: location.rlkDepartureEta,
                  rlkDepartureEtaFormatted: formatFromJsonDate(
                    location.rlkDepartureEta,
                  ),
                  rlkContactPersonId: location.rlkContactPersonId,
                  rlkAddress: location.rlkAddress,
                  rlkEmail: location.rlkEmail,
                  rlkContactNumber: location.rlkContactNumber,
                  rlkLon:
                    location.rlkLon !== null && location.rlkLon !== ""
                      ? parseFloat(location.rlkLon)
                      : null,
                  rlkLat:
                    location.rlkLat !== null && location.rlkLat !== ""
                      ? parseFloat(location.rlkLat)
                      : null,
                  rlkSeq: location.rlkSeq,
                  rlkActive: location.rlkActive,
                  requestConsigneesRequests: [],
                  rlkLocationContactNumber: location.rlkLocationContactNumber,
                  rlkLocationContactName: location.rlkLocationContactName,
                  rlkLocationTimeUpdated: location.rlkLocationTimeUpdated,
                  rlkPickDrop: location.rlkPickDrop,
                  rlkPickDropValue: location.rlkPickDropValue,
                },
              };
            } else {
              requestLocations = {
                ...requestLocations,
                requestViaLocations: [
                  ...requestLocations.requestViaLocations,
                  {
                    ...location,
                    id: parseInt(location.rlkSeq) + 1,
                    rlkId: location.rlkId,
                    rlkCode: location.rlkCode,
                    rlkLocation: location.rlkLocation,
                    rlkLocationType: location.rlkLocationType,
                    rlkArrivalEta: location.rlkArrivalEta,
                    rlkArrivalEtaFormatted: formatFromJsonDate(
                      location.rlkArrivalEta,
                    ),
                    rlkDepartureEta: location.rlkDepartureEta,
                    rlkDepartureEtaFormatted: formatFromJsonDate(
                      location.rlkDepartureEta,
                    ),
                    rlkContactPersonId: location.rlkContactPersonId,
                    rlkAddress: location.rlkAddress,
                    rlkEmail: location.rlkEmail,
                    rlkContactNumber: location.rlkContactNumber,
                    rlkLon:
                      location.rlkLon !== null && location.rlkLon !== ""
                        ? parseFloat(location.rlkLon)
                        : null,
                    rlkLat:
                      location.rlkLat !== null && location.rlkLat !== ""
                        ? parseFloat(location.rlkLat)
                        : null,
                    rlkSeq: location.rlkSeq,
                    rlkActive: location.rlkActive,
                    requestConsigneesRequests: [],
                    rlkLocationContactNumber: location.rlkLocationContactNumber,
                    rlkLocationContactName: location.rlkLocationContactName,
                    rlkLocationTimeUpdated: location.rlkLocationTimeUpdated,
                    rlkPickDrop: location.rlkPickDrop,
                    rlkPickDropValue: location.rlkPickDropValue,
                  },
                ],
              };
            }
          }

          dispatch(requestActions.setCurrentValues({ requestLocations }));
          dispatch(
            requestActions.setRequest({
              requestLocationsRequests: [
                requestLocations.requestStartLocation,
                requestLocations.requestEndLocation,
                ...requestLocations.requestViaLocations,
              ],
            }),
          );

          dispatch(requestActions.setConsignees(requestConsignees));
          dispatch(
            requestActions.setRequest({
              editModeConsigneeCount: requestConsignees.length + 2,
            }),
          );
          setIsLocConItemLoading(false);
          const requestOtherResponses = [];
          let otherId = 2;
          for (let value of response.requestOtherResponses) {
            requestOtherResponses.push({
              ...value,
              id: otherId++,
            });
          }
          dispatch(requestActions.setRequest({ editModeOtherCount: otherId }));
          dispatch(requestActions.setOther(requestOtherResponses));
          setIsOtherInfoLoading(false);
        }
      }
    })();

    return () => {
      dispatch(requestActions.resetRequest());
      dispatch(requestActions.setRequest({ viewOnlyMode }));
    };
  }, [editMode, response, dispatch, cleanUp]);

  const haveConsecutiveLocations = (locationMap) => {
    if (allowSameLocation) {
      return false;
    }
    const seqList = Object.keys(locationMap).map((seq) => +seq);
    const minSeq = Math.min(...seqList);
    const maxSeq = Math.max(...seqList);
    let prevLocation = locationMap[minSeq];
    for (let i = minSeq + 1; i <= maxSeq + 1; i++) {
      const currentLocation =
        locationMap[i] === undefined ? -1 : locationMap[i];
      if (currentLocation === prevLocation) {
        return true;
      }
      prevLocation = currentLocation;
    }
    return false;
  };

  const validateAndSortLocations = (requestLocations, bookingReqDate) => {
    const errors = [];
    const requestStartLocation = requestLocations.find(
      (location) => location.rlkLocationType === 1,
    );
    const requestEndLocation = requestLocations.find(
      (location) => location.rlkLocationType === 2,
    );

    // if (bookingReqDate > requestStartLocation.rlkArrivalEta) {
    //   dispatch(requestActions.setRequest({ hasLocErrors: true }));
    //   dispatch(
    //     requestActions.setRequest({
    //       startLocationErrors: {
    //         rlkArrivalEta:
    //           "Start location arrival eta cannot be before booking required date",
    //       },
    //     })
    //   );
    //   return;
    // }

    const startLocationErrors = validateRequestLocation(
      {
        ...requestStartLocation,
        rlkContactPersonId: requestStartLocation.rlkContactPersonId || null,
        rlkLocationContactName:
          requestStartLocation.rlkLocationContactName || null,
        rlkLocationContactNumber:
          requestStartLocation.rlkLocationContactNumber || null,
      },
      dynamicValidationStatusStart,
    );
    const endLocationErrors = validateRequestLocation(
      {
        ...requestEndLocation,
        rlkContactPersonId: requestEndLocation.rlkContactPersonId || null,
        rlkLocationContactName:
          requestEndLocation.rlkLocationContactName || null,
        rlkLocationContactNumber:
          requestEndLocation.rlkLocationContactNumber || null,
      },
      dynamicValidationStatusEnd,
    );
    const allLocations = [...requestLocations];

    const startLocationValidationFailed =
      Object.keys(startLocationErrors).length > 0;
    const endLocationValidationFailed =
      Object.keys(endLocationErrors).length > 0;

    if (startLocationValidationFailed) {
      dispatch(requestActions.setRequest({ hasLocErrors: true }));
      dispatch(requestActions.setRequest({ startLocationErrors }));
    }
    if (endLocationValidationFailed) {
      dispatch(requestActions.setRequest({ hasLocErrors: true }));
      dispatch(requestActions.setRequest({ endLocationErrors }));
    }

    if (startLocationValidationFailed || endLocationValidationFailed) {
      return null;
    }

    const viaLocations = allLocations.filter(
      (location) => location.rlkLocationType === 3 && location.rlkActive === 1,
    );
    const deletedViaLocations = allLocations.filter(
      (location) => location.rlkLocationType === 3 && location.rlkActive === 2,
    );
    const sortedLocations = [...viaLocations, requestStartLocation].sort(
      (a, b) => a.rlkSeq - b.rlkSeq,
    );
    sortedLocations.push(requestEndLocation);
    let prevLocation = null;
    let seq = 1;
    const validatedSortedList = [];
    for (let location of sortedLocations) {
      if (isBeforeJson(location.rlkDepartureEta, location.rlkArrivalEta)) {
        errors.push({
          error: "Departure date should be after arrival date",
          seq: location.rlkSeq,
        });
      }
      if (prevLocation) {
        if (
          isBeforeJson(location.rlkArrivalEta, prevLocation.rlkDepartureEta)
        ) {
          errors.push({
            error: "Arrival date should be after previous location departure",
            seq: location.rlkSeq,
          });
        } else {
          location = { ...location, rlkSeq: seq };
          seq++;
          validatedSortedList.push(location);
        }
      } else {
        location = { ...location, rlkSeq: seq };
        seq++;
        validatedSortedList.push(location);
      }
      prevLocation = location;
    }
    if (errors.length > 0) {
      dispatch(requestActions.setRequest({ validationErrors: errors }));
      dispatch(requestActions.setRequest({ hasLocErrors: true }));
      return null;
    } else {
      dispatch(requestActions.setRequest({ hasLocErrors: false }));
      const locationMap = validatedSortedList.reduce((acc, loc) => {
        acc[loc.rlkSeq] = loc.rlkLocation;
        return acc;
      }, {});
      if (haveConsecutiveLocations(locationMap)) {
        dispatch(requestActions.setRequest({ hasLocErrors: true }));
        toast.warn("Invalid Location order", {
          autoClose: 5000,
          containerId: "Main",
        });
        return null;
      }
      return [...validatedSortedList, ...deletedViaLocations];
    }
  };

  const handleLocationUpdate = (updatedLocations) => {
    dispatch(requestActions.updateLocations(updatedLocations));
    modalRef.current.close();
  };

  const handleNext = () => {
    switch (step) {
      case 1: {
        const requestErrors = requestInitRef.current.validateForm();
        if (Object.entries(requestErrors).length > 0) {
          setNextValidated(1);
          setHasRequestInitErrors(true);
          dispatch(
            errorActions.addRequestCreationErrorObject({
              form: "requestErrors",
              errors: requestErrors,
            }),
          );

          return;
        } else {
          setNextValidated(null);
          setHasRequestInitErrors(false);
          dispatch(errorActions.clearRequestCreationError());
        }
        break;
      }
      case 2: {
        if (reqCreateType === 1) {
          let hasErrors = false;
          const requestTransportErrors =
            requestTransportRef.current.validateForm();
          if (Object.entries(requestTransportErrors).length > 0) {
            setNextValidated(2);
            setHasRequestTransportErrors(true);
            dispatch(
              errorActions.addRequestCreationErrorObject({
                form: "transportErrors",
                errors: requestTransportErrors,
              }),
            );
            hasErrors = true;
          }
          if (hasErrors) {
            return;
          } else {
            dispatch(
              requestActions.removeTransportError({
                key: "rcoCbm",
              }),
            );
            setHasRequestTransportErrors(false);
            setNextValidated(null);
          }
        } else {
          let hasErrors = true;
          if (requestMultipleJobs?.length === 0) {
            hasErrors = true;
            toast.error("At least one active record is required", {
              autoClose: 5000,
              containerId: "Main",
            });
            setNextValidated(2);
            setHasRequestTransportErrors(true);
          }
          for (let requestMultipleJob of requestMultipleJobs) {
            if (requestMultipleJob.rmjActive === 1) {
              hasErrors = false;
            }
          }
          if (hasErrors) {
            toast.error("At least one active record is required", {
              autoClose: 5000,
              containerId: "Main",
            });
            setNextValidated(2);
            setHasRequestTransportErrors(true);
            return;
          } else {
            setHasRequestTransportErrors(false);
            setNextValidated(null);
          }
        }
        break;
      }
      case 3: {
        const requestState = store.getState();
        const requestData = requestState.request;
        const locations = requestData.requestLocationsRequests;

        const sortedLocation = validateAndSortLocations(
          locations,
          requestData.startArrivalTime,
        );
        if (!sortedLocation) {
          setNextValidated(3);
          toast.error("Error adding locations", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        } else {
          setNextValidated(null);
        }

        if (requestData.reqMultiConsignee === 1) {
          const reqConsignees = requestData.requestConsigneesRequests;
          const activeConsignees = reqConsignees.filter(
            (item) => item.rcoId || item.rcoActive === 1,
          );
          if (activeConsignees.length < 2) {
            dispatch(
              requestActions.setRequest({
                hasConErrors: true,
                consigneeValidationErrors: [
                  {
                    error: "At least 2 consignees are required",
                  },
                ],
              }),
            );
            toast.error("At least 2 consignees are required", {
              autoClose: 5000,
              containerId: "Main",
            });
            return;
          }
        } else {
          setNextValidated(null);
        }
        break;
      }
      case 4: {
        const requestState = store.getState();
        const requestData = requestState.request;
        if (reqCreateType === 1) {
          let summaryValidationErrors =
            requestSummaryRef?.current?.validateForm();

          if (Object.keys(summaryValidationErrors).length > 0) {
            setNextValidated(4);
            dispatch(
              requestActions.setRequest({
                hasConErrors: true,
                hasSummaryErrors: true,
                requestSummaryErrors: {
                  ...summaryValidationErrors,
                },
              }),
            );
            setHasRequestSummaryErrors(true);
            return;
          }

          if (shouldValidateSummaryCBM === 1) {
            if (requestData.reqCbm !== 0 && requestData.vehicleMaxCbm) {
              if (requestData.reqCbm > requestData.vehicleMaxCbm) {
                setNextValidated(4);
                dispatch(
                  requestActions.setRequest({
                    hasConErrors: true,
                    hasSummaryErrors: true,
                    requestSummaryErrors: {
                      ...summaryValidationErrors,
                      reqCbm: "CBM should be less than vehicle max CBM",
                    },
                  }),
                );
                setHasRequestSummaryErrors(true);
                return;
              } else {
                if (shouldValidateReqScheduler === 1) {
                  let schedulerErrors = [];
                  const scheduleType =
                    requestSummaryRef.current.getRequestSchedulerData()
                      .rscScheduleType;
                  if (scheduleType !== null) {
                    if (scheduleType === 1) {
                      schedulerErrors = schedulerOneDayValidation(
                        requestSummaryRef.current.getRequestSchedulerData(),
                      );
                    } else if (scheduleType === 4) {
                      schedulerErrors = schedulerMonthlyValidation(
                        requestSummaryRef.current.getRequestSchedulerData(),
                      );
                    } else {
                      schedulerErrors = schedulerValidation(
                        requestSummaryRef.current.getRequestSchedulerData(),
                      );
                    }
                  }

                  if (Object.keys(schedulerErrors).length > 0) {
                    dispatch(
                      errorActions.addRequestScheduleErrorObject({
                        form: "requestSchedulerErrors",
                        errors: schedulerErrors,
                      }),
                    );
                    toast.error("There was an error Request Scheduler", {
                      autoClose: 5000,
                      containerId: "Main",
                    });
                    return;
                  } else {
                    setNextValidated(null);
                    setHasRequestSummaryErrors(false);
                  }
                }
              }
            } else {
              setNextValidated(4);
              dispatch(
                requestActions.setRequest({
                  hasConErrors: true,
                  hasSummaryErrors: true,
                  requestSummaryErrors: {
                    ...summaryValidationErrors,
                    reqCbm:
                      requestData.reqCbm === null ||
                      requestData.reqCbm === "" ||
                      requestData.reqCbm === 0
                        ? "No request CBM"
                        : "No vehicle max CBM",
                  },
                }),
              );
              setHasRequestSummaryErrors(false);
              return;
            }
          }
        }

        break;
      }
      default:
    }
    setStep(next());
  };

  const handlePrev = () => {
    setStep(prev());
  };

  //submit function
  const submitHandler = async (approveAfterCreate = false) => {
    setIsSubmitLoading(true);

    const requestState = store.getState();
    const requestData = requestState.request;
    let data = {};

    setHasRequestInitErrors(false);
    setHasRequestTransportErrors(false);
    setHasRequestSummaryErrors(false);
    dispatch(requestActions.setRequest({ submitted: true }));
    dispatch(requestActions.resetErrors());
    let hasErrors = false;

    const requestInitData = requestInitRef.current?.getData();
    const reqInitErrors = requestInitRef.current?.validateForm();

    setHasRequestInitErrors(Object.keys(reqInitErrors).length > 0);
    if (Object.keys(reqInitErrors).length > 0) {
      hasErrors = true;
      dispatch(requestActions.setRequest({ requestInitErrors: reqInitErrors }));
    }

    const reqConfirmationStatus =
      requestTransportRef.current?.getRequestConfirmationStatus();
    const reqCreationType =
      requestTransportRef.current?.getRequestCreationType();
    const requestTransportData = requestTransportRef.current?.getData();
    let multiRequestTransporterData =
      requestTransportRef.current?.getMultiRequestTransporterData();

    if (reqCreateType === 1) {
      let reqTransportErrors = requestTransportRef.current?.validateForm();

      if (requestData.reqMultiConsignee === 2) {
        const singleConsigneeData =
          requestTransportRef.current.getSingleConsignee();
        // if (
        //   singleConsigneeData.rcoCbm === null ||
        //   singleConsigneeData.rcoCbm === ""
        // ) {
        //   reqTransportErrors = {
        //     ...reqTransportErrors,
        //     rcoCbm: "CBM is required",
        //   };
        // } else {
        //   if (singleConsigneeData.rcoCbm === 0) {
        //     reqTransportErrors = {
        //       ...reqTransportErrors,
        //       rcoCbm: "CBM is required",
        //     };
        //   }
        // }
      }
      setHasRequestTransportErrors(Object.keys(reqTransportErrors).length > 0);
      if (Object.keys(reqTransportErrors).length > 0) {
        hasErrors = true;
        dispatch(
          requestActions.setRequest({
            requestTransporterErrors: reqTransportErrors,
          }),
        );
      }
    } else {
      let hasErrors = true;
      if (requestMultipleJobs?.length === 0) {
        hasErrors = true;
        toast.error("At least one active record is required", {
          autoClose: 5000,
          containerId: "Main",
        });
        setHasRequestTransportErrors(true);
        setIsSubmitLoading(false);
        return;
      }
      for (let requestMultipleJob of requestMultipleJobs) {
        if (requestMultipleJob.rmjActive === 1) {
          hasErrors = false;
        }
      }
      if (hasErrors) {
        toast.error("At least one active record is required", {
          autoClose: 5000,
          containerId: "Main",
        });
        setHasRequestTransportErrors(true);
        setIsSubmitLoading(false);
        return;
      } else {
        setHasRequestTransportErrors(false);
      }
    }

    const requestSummaryFormData = requestSummaryRef.current?.getData();

    const requestSummaryData = {
      ...requestSummaryFormData,
      reqCbm: requestData.reqCbm,
      reqQty: requestData.reqQty,
    };
    const requestSchedulerData =
      requestSummaryRef.current?.getRequestSchedulerData();

    if (reqCreateType === 1) {
      let summaryValidationErrors = requestSummaryRef?.current?.validateForm();

      if (Object.keys(summaryValidationErrors).length > 0) {
        setHasRequestSummaryErrors(true);
        dispatch(
          requestActions.setRequest({
            hasConErrors: true,
            hasSummaryErrors: true,
            requestSummaryErrors: {
              ...summaryValidationErrors,
            },
          }),
        );
        hasErrors = true;
        setHasRequestSummaryErrors(true);
      }

      if (shouldValidateSummaryCBM === 1) {
        if (requestData.reqCbm !== 0 && requestData.vehicleMaxCbm) {
          if (requestData.reqCbm > requestData.vehicleMaxCbm) {
            dispatch(
              requestActions.setRequest({
                hasConErrors: true,
                hasSummaryErrors: true,
                requestSummaryErrors: {
                  ...summaryValidationErrors,
                  reqCbm: "CBM should be less than vehicle max CBM",
                },
              }),
            );
            hasErrors = true;
            setHasRequestSummaryErrors(true);
          }
        } else {
          dispatch(
            requestActions.setRequest({
              hasConErrors: true,
              hasSummaryErrors: true,
              requestSummaryErrors: {
                ...summaryValidationErrors,
                reqCbm:
                  requestData.reqCbm === null ||
                  requestData.reqCbm === "" ||
                  requestData.reqCbm === 0
                    ? "No request CBM"
                    : "No vehicle max CBM",
              },
            }),
          );
          hasErrors = true;
          setHasRequestSummaryErrors(true);
        }
      }
    }

    if (shouldValidateReqScheduler === 1) {
      const scheduleType =
        requestSummaryRef.current.getRequestSchedulerData().rscScheduleType;
      let schedulerErrors = [];
      if (scheduleType !== undefined && scheduleType !== null) {
        if (scheduleType === 1) {
          schedulerErrors = schedulerOneDayValidation(
            requestSummaryRef.current.getRequestSchedulerData(),
          );
        } else if (scheduleType === 4) {
          schedulerErrors = schedulerMonthlyValidation(
            requestSummaryRef.current.getRequestSchedulerData(),
          );
        } else {
          schedulerErrors = schedulerValidation(
            requestSummaryRef.current.getRequestSchedulerData(),
          );
        }

        if (Object.keys(schedulerErrors).length > 0) {
          dispatch(
            errorActions.validateRequestScheduler({
              schedulerData: schedulerErrors,
            }),
          );
          setIsSubmitLoading(false);
          return;
        }
      }
    }

    const locations = requestData.requestLocationsRequests;

    const sortedLocation = validateAndSortLocations(
      locations,
      requestData.startArrivalTime,
    );

    if (!sortedLocation) {
      hasErrors = true;
    }
    if (hasErrors) {
      toast.error("Error creating request", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsSubmitLoading(false);
      return;
    }
    let mappedSortedLocation = [];

    if (requestData.reqMultiConsignee === 1) {
      const reqConsignees = requestData.requestConsigneesRequests;
      const activeConsignees = reqConsignees.filter(
        (item) => item.rcoId || item.rcoActive === 1,
      );
      if (activeConsignees.length < 2) {
        dispatch(
          requestActions.setRequest({
            hasConErrors: true,
            consigneeValidationErrors: [
              {
                error: "At least 2 consignees are required",
              },
            ],
          }),
        );
        toast.error("Error creating request", {
          containerId: "Main",
          autoClose: 3000,
        });
        setIsSubmitLoading(false);
        return;
      }
      mappedSortedLocation = sortedLocation.map((location) => {
        activeConsignees.forEach((consignee) => {
          if (consignee.rcoLocation === location.rlkLocation) {
            location = {
              ...location,
              requestConsigneesRequests: [
                ...location.requestConsigneesRequests,
                {
                  rcoLocation: consignee.rcoLocation,
                  rcoConsignee: consignee.rcoConsignee,
                  rcoConsignmentType: consignee.rcoConsignmentType,
                  rcoCbm: consignee.rcoCbm,
                  rcoQty: consignee.rcoQty,
                  rcoActive: consignee.rcoActive,
                  requestItemsRequests: [],
                },
              ],
            };
          }
        });
        return location;
      });
    } else {
      const singleConsigneeData =
        requestTransportRef.current.getSingleConsignee();
      let consignee = null;
      consignee = {
        rcoConsignee: requestData.singleConsignee,
        rcoCbm: requestData.reqQty,
        rcoQty: requestData.reqCbm,
      };

      mappedSortedLocation = sortedLocation.map((location) => {
        location = {
          ...location,
          requestConsigneesRequests: consignee.rcoConsignee
            ? [
                {
                  rcoCbm: 0,
                  rcoQty: 0,
                  rcoConsignee: singleConsigneeData.rcoConsignee,
                  rcoLocation: location.rlkLocation,
                  rcoActive: 1,
                  requestItemsRequests: [],
                },
              ]
            : [
                {
                  rcoCbm: 0,
                  rcoQty: 0,
                  rcoConsignee: null,
                  rcoLocation: location.rlkLocation,
                  rcoActive: 2,
                  requestItemsRequests: [],
                },
              ],
        };
        return location;
      });
    }

    const startLocation = mappedSortedLocation.find(
      (location) => location.rlkLocationType === 1,
    );
    const endLocation = mappedSortedLocation.find(
      (location) => location.rlkLocationType === 2,
    );

    const reqStarkRlkId = startLocation.rlkLocation;
    const reqEndRlkId = endLocation.rlkLocation;
    const reqOthers = requestData.requestOtherRequests;

    const activeOthers = reqOthers.filter(
      (item) => item.rotId || item.rotActive === 1,
    );

    const documents = docRef.current.getData();

    data = {
      ...requestInitData,
      reqBookingRequiredDate: requestData.startArrivalTime,
      ...requestTransportData,
      ...requestSummaryData,
      reqStarkRlkId,
      reqEndRlkId,
      reqConfirmationStatus: reqConfirmationStatus,
      reqCreationType: reqCreationType,
      requestLocationsRequests: mappedSortedLocation,
      requestSchedulerRequests: requestSchedulerData,
      requestOtherRequests: activeOthers.map((other) => {
        return { ...other, rotId: null };
      }),
      requestMultipleJobRequests: multiRequestTransporterData,
      author: user.username,
    };

    try {
      let response = null;
      if (editMode) {
        const res = await updateRequestInitiation({
          ...data,
          context: reqContext,
          jobId: jobId,
        });
        if (res.status < 0) {
          toast.error(res.message, {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        }
        let hasUploadErrors = false;
        for (let doc of documents.created) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append("documentRequest", JSON.stringify(rest));
          formData.append("isImage", rest.docCategory === 1);
          const res = await addAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            docRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error adding document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }
        for (let doc of documents.modified) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append("documentRequest", JSON.stringify(rest));
          formData.append("isImage", rest.docCategory === 1);
          const res = await updateAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            docRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error updating document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }

        if (documents?.deleted.length > 0) {
          await deleteDocumentList({
            docIdList: documents?.deleted,
          });
          toast.success("Documents deleted successfully!", {
            autoClose: 5000,
            containerId: "Main",
          });
        }

        toast.success(`Request successfully updated `, {
          autoClose: 5000,
          containerId: "Main",
        });

        if (hasUploadErrors) {
          setIsSubmitLoading(false);
          return;
        }

        setEditMode(false);
        if (cleanUp) {
          cleanUpFunction();
        } else {
          window.location.reload();
        }
      } else {
        if (createdRequestId) {
          const backhaulResponse =
            await fetchBackhaulSuggestions(createdRequestId);
          const suggestions = backhaulResponse?.suggestions ?? [];
          if (suggestions.length > 0) {
            setBackhaulSuggestions(suggestions);
            setSelectedBackhaul(null);
            backhaulModalRef.current?.showModal();
          } else {
            toast.success(
              `Request ${createdRequestCode} successfully created`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
            dispatch(requestActions.resetRequest());
            setStep(1);
            setCreatedRequestId(null);
            setCreatedRequestCode("");
          }
          setIsSubmitLoading(false);
          return;
        }
        const payload = {
          ...data,
          reqComId: userCompany ? userCompany.comId : null,
        };

        const returnedResponse = approveAfterCreate
          ? await createAndApproveRequestInitiation(payload)
          : await addRequestInitiation(payload);

        if (approveAfterCreate) {
          if (!returnedResponse?.success) {
            toast.error(
              returnedResponse?.message ||
                "Error creating and approving request",
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
            setIsSubmitLoading(false);
            return;
          }

          toast.success(
            `Request ${returnedResponse.reqCode} created and Job ${returnedResponse.jobCode} generated successfully`,
            { autoClose: 5000, containerId: "Main" },
          );

          dispatch(requestActions.resetRequest());
          setStep(1);
          setCreatedRequestId(null);
          setCreatedRequestCode("");
          setIsSubmitLoading(false);
          return;
        }
        response = returnedResponse?.response;

        if (response?.reqId) {
          setCreatedRequestId(response.reqId);
          setCreatedRequestCode(response.reqCode);

          const backhaulResponse = await fetchBackhaulSuggestions(
            response.reqId,
          );
          const suggestions = backhaulResponse?.suggestions ?? [];

          if (suggestions.length > 0) {
            setBackhaulSuggestions(suggestions);
            setSelectedBackhaul(null);
            backhaulModalRef.current?.showModal();
            setIsSubmitLoading(false);
            return;
          }
        }

        let hasUploadErrors = false;
        for (let doc of documents) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append(
            "documentRequest",
            JSON.stringify({
              ...rest,
              docReference: response.reqId,
            }),
          );
          formData.append("isImage", rest.docCategory === 1);
          const res = await addAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Main",
            });
          } else {
            hasUploadErrors = true;
            docRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error adding document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Main",
              },
            );
          }
        }
        const documentResponses = await getDocumentByOpeAndRef(
          7,
          response.reqId,
        );
        response = { ...response, documentResponses };

        toast.success(`Request ${response.reqCode} successfully created `, {
          autoClose: 5000,
          containerId: "Main",
        });
        if (hasUploadErrors) {
          setIsSubmitLoading(false);
          return;
        }
        dispatch(requestActions.resetRequest());
      }
      setResponse(response);
      setEditMode(true);
      setStep(1);
      setIsSubmitLoading(false);
    } catch (e) {
      if (e?.response?.data?.message) {
        toast.error(e?.response?.data?.message, {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error("Error creating request", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
      setIsSubmitLoading(false);
    }
  };

  const backhaulGridConfig = [
    {
      headerName: "",
      field: "select",
      width: 70,
      cellRenderer: (params) => (
        <input
          type="radio"
          name="backhaulSelect"
          checked={
            selectedBackhaul?.originalJobId === params.data.originalJobId &&
            selectedBackhaul?.originalReqId === params.data.originalReqId
          }
          onChange={() => setSelectedBackhaul(params.data)}
        />
      ),
    },
    { headerName: "Request Code", field: "originalReqCode" },
    { headerName: "Job Code", field: "originalJobCode" },
    { headerName: "Vehicle No", field: "vehicleNo" },
    {
      headerName: "Transporter",
      field: "transporterName",
      cellRenderer: ResizableScrollingTextRenderer,
    },
    { headerName: "Driver", field: "driverName" },
    {
      headerName: "Origin",
      field: "originLocName",
      cellRenderer: ResizableScrollingTextRenderer,
    },
    { headerName: "Start Arrival", field: "startArrival" },
    { headerName: "Start Departure", field: "startDeparture" },
    {
      headerName: "Destination",
      field: "destLocName",
      cellRenderer: ResizableScrollingTextRenderer,
    },
    { headerName: "Last Arrival", field: "lastArrival" },
    { headerName: "Last Departure", field: "lastDeparture" },
  ];

  const handleBackhaulClose = () => {
    backhaulModalRef.current?.close();
    toast.success(`Request ${createdRequestCode} successfully created`, {
      autoClose: 5000,
      containerId: "Main",
    });

    dispatch(requestActions.resetRequest());
    setStep(1);
    setCreatedRequestId(null);
    setCreatedRequestCode("");
  };

  const handleBackhaulAction = async (status) => {
    if (!selectedBackhaul || !createdRequestId) return;

    try {
      const payload = {
        originalJobId: selectedBackhaul.originalReqId,
        backhaulRequestId: createdRequestId,
        status,
        approvalSource: "REQUEST_CREATION",
      };

      await approveBackhaul(payload);

      backhaulModalRef.current?.close();

      toast.success(`Backhaul request created for ${createdRequestCode}`, {
        autoClose: 5000,
        containerId: "Main",
      });

      setEditMode(false);
      setResponse({});
      dispatch(requestActions.resetRequest());
      setStep(1);
      setCreatedRequestId(null);
      setCreatedRequestCode("");
    } catch (e) {
      toast.error("Backhaul approval failed", {
        autoClose: 5000,
        containerId: "Main",
      });
    }
  };

  return (
    <div className="ui card" style={{ width: "100%" }}>
      <div className="content" style={{ width: "100%", cursor: "pointer" }}>
        <Card className="stakeholder-card-container">
          <CardContent>
            <div
              className="ui steps"
              style={{ width: "100%", display: "flex", flexDirection: "row" }}
            >
              <WizardTab
                submitted={submitted}
                nextValidated={nextValidated === 1}
                errors={hasRequestInitErrors}
                active={step === 1}
                authenticated={true}
                form={FORMS.REQUEST.CREATION.form}
                onClick={() => setStep(1)}
                title="Request Initiation"
                description="Fill Your Request"
                icon="file icon"
                showMandatory={true}
                isMandatory={true}
              />
              <WizardTab
                submitted={submitted}
                nextValidated={nextValidated === 2}
                errors={hasRequestTransportErrors}
                active={step === 2}
                onClick={() => setStep(2)}
                authenticated={true}
                form={FORMS.REQUEST.TRANSPORT.form}
                title="Transport Information"
                description="Enter transport information"
                icon="truck icon"
                showMandatory={true}
                isMandatory={true}
              />
              <WizardTab
                submitted={submitted}
                nextValidated={nextValidated === 3}
                errors={hasLocErrors || hasConErrors}
                active={step === 3}
                onClick={() => setStep(3)}
                authenticated={true}
                form={FORMS.REQUEST.LOCATION.form}
                title="Location/Consignee/Item"
                description="Enter the Information"
                icon="map icon"
                showMandatory={true}
                isMandatory={true}
              />
              <WizardTab
                submitted={submitted}
                nextValidated={nextValidated === 4}
                errors={hasRequestSummaryErrors}
                active={step === 4}
                onClick={() => setStep(4)}
                authenticated={true}
                form={FORMS.REQUEST.SUMMARY.form}
                title="Summary Information"
                description="Enter the Information"
                icon="list icon"
              />
              <WizardTab
                active={step === 5}
                onClick={() => setStep(5)}
                title="Other Information"
                description="Enter the Information"
                authenticated={true}
                form={FORMS.REQUEST.OTHER.form}
                icon="info icon"
              />
              <WizardTab
                active={step === 6}
                onClick={() => setStep(6)}
                title="Document Upload"
                description="Upload your documents"
                authenticated={true}
                form={FORMS.REQUEST.DOCUMENT.form}
                icon="upload icon"
              />
            </div>
          </CardContent>
        </Card>
      </div>
      {isLoading || isFetchLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div
            className="content"
            style={{
              display: step === 1 ? "block" : "none",
              height: "55vh",
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
          >
            <RequestCreationInitiation
              ref={requestInitRef}
              editMode={editMode}
              dropdown={{
                departmentTypeOptions,
                shipmentTypeOptions,
                shipmentCategoryOptions,
                yesNoOptions,
                requestType,
              }}
            />
          </div>
          <div
            className="content"
            style={{
              display: step === 2 ? "block" : "none",
              height: "55vh",
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
          >
            <RequestTransporter
              ref={requestTransportRef}
              isLoading={isTransportLoading}
              editMode={editMode}
              dropdown={{
                itemTypeOptions,
                consignmentTypeOptions,
                yesNoOptions,
                requestTypeOptions,
                confirmationTypeOptions,
                kagTypes,
              }}
            />
          </div>
          <div
            className="content"
            style={{
              display: step === 3 ? "block" : "none",
              height: "55vh",
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
          >
            <LocationConsigneeItem
              onShowLocation={() => {
                modalRef.current?.showModal();
              }}
              editMode={editMode}
              dropdown={{
                locationFlagOptions,
                consignmentTypeOptions,
                pickDropTypeOptions,
              }}
              isLoading={isLocConItemLoading}
              context={reqContext}
            />
          </div>
          <div
            className="content"
            style={{
              display: step === 4 ? "block" : "none",
              height: "55vh",
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
          >
            <RequestSummaryInformation
              ref={requestSummaryRef}
              editMode={editMode}
              dropdown={{
                uomTypeOptions,
                statusTypeOptions,
                scheduleTypeOptions,
                activeOptions,
                timeUomOptions,
              }}
            />
          </div>
          <div
            className="content"
            style={{
              display: step === 5 ? "block" : "none",
              height: "55vh",
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
          >
            <RequestOther
              ref={requestOtherRef}
              dropdown={{ chargeTypeOptions, statusTypeOptions }}
              editMode={editMode}
              isLoading={isOtherInfoLoading}
            />
          </div>

          <div
            className="content"
            style={{
              display: step === 6 ? "block" : "none",
              height: "55vh",
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
          >
            <DocumentUpload
              viewOnlyMode={viewOnlyMode}
              reference={docReference}
              module={MODULES.Transaction}
              opeType={7}
              ref={docRef}
              dropdown={{
                documentTypeOptions,
                statusOptions: statusTypeOptions,
                fileNameOptions,
                activeOptions,
              }}
              isLoading={isFetchLoading}
              editMode={editMode}
              currentValues={currentDocuments}
            />
          </div>
        </>
      )}
      <div
        className="extra content"
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {showResetButton && (
          <Button
            label="Reset Form"
            Icon={GrFormRefresh}
            onClick={() => {
              window.location.reload();
            }}
          />
        )}
        {/*{showResetButton && (*/}
        {/*    <Button*/}
        {/*        label="Reset Form"*/}
        {/*        Icon={GrFormRefresh}*/}
        {/*        onClick={() => {*/}
        {/*          dispatch(requestActions.resetRequest());*/}
        {/*          setStep(1);*/}
        {/*          setEditMode(false);*/}
        {/*          setResponse({});*/}
        {/*        }}*/}
        {/*    />*/}
        {/*)}*/}
        <Button
          template="back"
          tab={step - 1}
          module={MODULES.Transaction}
          section={FORMS.REQUEST}
          authenticated={true}
          onClick={handlePrev}
        />

        {step < lastViableTab && (
          <Button
            template="next"
            tab={step + 1}
            module={MODULES.Transaction}
            section={FORMS.REQUEST}
            authenticated={true}
            onClick={handleNext}
          />
        )}
        {editMode ? (
          <Button
            template="submit"
            disabled={viewOnlyMode}
            onClick={submitHandler}
            isLoading={isSubmitLoading}
            create={!editMode}
            form={FORMS.REQUEST.CREATION.form}
            module={MODULES.Transaction}
            authenticated={true}
            editMode={editMode}
          />
        ) : step === lastViableTab ? (
          <>
            <Button
              template="submit"
              disabled={viewOnlyMode}
              onClick={() => submitHandler(false)}
              isLoading={isSubmitLoading}
              create={!editMode}
              form={FORMS.REQUEST.CREATION.form}
              module={MODULES.Transaction}
              authenticated={true}
              editMode={editMode}
            />
            {canSaveApprove && (
              <Button
                label="Save & Approve"
                disabled={viewOnlyMode}
                onClick={() => submitHandler(true)}
                isLoading={isSubmitLoading}
                form={FORMS.REQUEST.REQUEST_SAVE_APPROVE.form}
                module={MODULES.Transaction}
                authenticated={true}
              />
            )}
          </>
        ) : (
          ""
        )}
      </div>
      <Modal ref={modalRef}>
        <LocationMap
          onUpdate={handleLocationUpdate}
          onClose={() => {}}
          context={reqContext}
        />
      </Modal>

      <Modal
        ref={modalRef2}
        minWidth="70vw"
        clickOutSide={false}
        closeButton={false}
      >
        <JobConfirmationAlert
          alerts={jobConfirmAlerts}
          closeModal2={closeModal2}
        />
      </Modal>

      <Modal ref={backhaulModalRef} minWidth="70vw" clickOutSide={false}>
        <div style={{ padding: "16px" }}>
          <h3>Backhaul Suggestions</h3>

          <Grid
            content={backhaulSuggestions}
            config={backhaulGridConfig}
            pagination={true}
            pageSize={10}
            searchable={false}
            autoHeight={false}
            vrScroll={true}
            gridHeight={400}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "16px",
            }}
          >
            <button
              className="ui button"
              type="button"
              onClick={handleBackhaulClose}
            >
              Close
            </button>

            <button
              className="ui green button"
              type="button"
              disabled={!selectedBackhaul}
              onClick={() => handleBackhaulAction(2)}
            >
              Approve
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default RequestCreationRefactor;
